// Strips HTML tags from plain-text fields (task/subtask names, comments, etc.)
// so markup like `<marquee><a href=...>ClickME</a>` can never be stored/rendered
// as live HTML — only the harmless inner text survives.
export function stripHtml(value = "") {
  return String(value)
    .replace(/<[^>]*>/g, "")
    .trim();
}
